// react
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAsp';

// types
import { OrderType } from 'types/order';

const AdTrackTag = () => {
  const { isThanks, order } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'ad-track';
    const cvScriptId = 'ad-track-cv';
    const isExistScript = document.getElementById(scriptId);
    const isExistCvScript = document.getElementById(cvScriptId);
    if (!!isExistScript) isExistScript.remove();
    if (!!isExistCvScript) isExistCvScript.remove();

    const orderCode = order ? (order as OrderType).order_code : '';
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = isThanks ? 'https://ad-track.jp/ad/js/cv.js' : 'https://ad-track.jp/ad/js/lpjs.js';

    if (isThanks) {
      script.onload = () => {
        const cvScript = document.createElement('script');
        cvScript.id = cvScriptId;
        cvScript.innerHTML = `adtrack_cv.cv('adm_adtr_xuid', 'https://ad-track.jp/ad', '_buyer=31105&_article=27129&_buid=${orderCode}&key1=');`;
        document.body.appendChild(cvScript);
      };
    }

    document.body.appendChild(script);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isThanks, order]);

  return <></>;
};

export default AdTrackTag;
